import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'arraySlice'
})
export class ArraySlicePipe implements PipeTransform {

    transform(list: Array<any>, count: number): Array<any> {
        count = (count === null ? list.length : count);
        return list.slice(0, count);
    }

}
